import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeCards as removeCardsFromList
} from '../redux/lists'

export default function * requestRemoveAllCardsFromList (action) {
  const { id, archivedOnly } = action.payload

  const state = yield select()

  const list = state['view-myboard'].lists[id]

  if (!list) return

  const optimisticAction = yield optimisticPut(removeCardsFromList({
    id,
    cardIds:
      archivedOnly
        ? list.cards.filter(cardId => state['view-myboard'].cards[cardId].isArchived)
        : list.cards
  }))

  try {
    yield call(apiAction, 'RemoveCardsInVList', {
      id,
      archivedOnly
    })
  } finally {
    yield optimisticAction.revert()
  }
}
